import React from 'react';
import { Box, Skeleton, Divider } from '@mui/material';

const ChatCardSkeleton: React.FC = () => {
  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, mb: 2, p: 2 }}>
      <Box display="flex" alignItems="center" mb={2}>
        <Skeleton variant="text" width={80} height={20} />
        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
        <Skeleton variant="text" width={120} height={20} />
        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
        <Skeleton variant="text" width={100} height={20} />
      </Box>

      <Box mb={1} display="flex" justifyContent="flex-end">
        <Skeleton variant="rectangular" height={40} width={350} sx={{ borderRadius: 10 }} />
      </Box>
      <Box mb={1} display="flex" justifyContent="flex-start">
        <Skeleton variant="rectangular" height={40} width={400} sx={{ borderRadius: 10 }} />
      </Box>

      <Box mt={2}>
        <Skeleton variant="text" width={100} height={20} />
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1, mt: 1 }} />
      </Box>
    </Box>
  );
};

export default ChatCardSkeleton;
